import React from 'react';
import styled from 'styled-components';

const Screen = styled.div`
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f6fa;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

const Card = styled.div`
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
    padding: 40px 48px;
    max-width: 480px;
    text-align: center;
`;

const Icon = styled.div`
    font-size: 48px;
    margin-bottom: 16px;
`;

const Title = styled.h1`
    font-size: 22px;
    color: #c0392b;
    margin: 0 0 12px;
`;

const Message = styled.p`
    color: #444;
    font-size: 15px;
    line-height: 1.5;
    margin: 0 0 8px;
`;

const UserInfo = styled.p`
    color: #888;
    font-size: 13px;
    margin: 0 0 24px;
`;

const LogoutButton = styled.button`
    background: #2c3e50;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 10px 24px;
    font-size: 14px;
    cursor: pointer;

    &:hover {
        background: #34495e;
    }
`;

interface AccessDeniedProps {
    username: string;
    onLogout: () => void;
}

/**
 * Shown when an authenticated user lacks the SUPER_ADMIN realm role.
 * The application itself never mounts for such users.
 */
const AccessDenied: React.FC<AccessDeniedProps> = ({ username, onLogout }) => (
    <Screen>
        <Card>
            <Icon aria-hidden="true">🔒</Icon>
            <Title>Access denied — super admin only</Title>
            <Message>
                The AI-Search Tools are restricted to users with the{' '}
                <strong>SUPER_ADMIN</strong> role. Your account does not have
                this role.
            </Message>
            <UserInfo>Signed in as {username}</UserInfo>
            <LogoutButton type="button" onClick={onLogout}>
                Sign out
            </LogoutButton>
        </Card>
    </Screen>
);

export default AccessDenied;
